import React, {useState} from 'react'
import {DiagnosisType} from '../../../../utils/types'
import {DeleteFilled, EditFilled} from '@ant-design/icons'
import {styles} from '../../styles/TherapySection.style'
import {Color} from '../../../../style/custom/colors'
import {Button, Tooltip} from 'antd'
import {i18n} from '../../../../i18n'
import {ActionButtons, CustomModal, InputLabel} from '../../../common'
import EditDiagnosis from '../../actions/EditDiagnosis'
import {sharedStyles} from '../../../../style/shared_styles'
import {ButtonStyle} from '../../../../style/button'

/**
 * Component representing a patient diagnosis entry.
 */
const DiagnosisEntry: React.FC<DiagnosisEntryProps> = props => {
    const diagnosis = props.diagnosis

    const [modalVisible, setModalVisible] = useState(false)

    const closeModal = () => {
        setModalVisible(false)
    }

    const deleteEntry = () => {
        props.onDelete(diagnosis.id)
        setModalVisible(false)
    }

    const openModal = () => setModalVisible(true)

    return (
        <div style={{display: 'contents'}}>
            <Tooltip title={i18n.t('button.edit')}>
                {diagnosis.id && !props.hasOperationsErrors && <EditFilled style={styles.icon} onClick={() => props.onEdit(diagnosis)} />}
            </Tooltip>
            <div style={styles.codeContainer}>
                <span style={{color: Color.white}}>{diagnosis.icdCode}</span>
            </div>
            <div style={styles.name}>
                <span>{diagnosis.titleOfficial}</span>
            </div>
            <div style={styles.name}>
                <span>{diagnosis.title}</span>
            </div>
            <Tooltip title={i18n.t('button.edit')}>
                {diagnosis.id && !props.hasOperationsErrors && <DeleteFilled style={styles.icon} onClick={() => openModal()} />}
            </Tooltip>

            <CustomModal title={i18n.t('diagnosis.dialogTitle')} open={modalVisible}>
                <InputLabel label={i18n.t('diagnosis.dialogContent')}></InputLabel>
                
                <div style={{marginTop: 32, display: 'flex'}}>
                    <div style={sharedStyles.actionBtnLeft}>
                        <Button type={'default'} shape={'round'} style={ButtonStyle.primary} onClick={closeModal}>
                            {i18n.t('button.cancel')}
                        </Button>
                    </div>

                    <div style={sharedStyles.actionBtnRight}>
                        <Button
                            type={'primary'}
                            shape={'round'}
                            style={{...ButtonStyle.primary, color: 'white'}}
                            onClick={deleteEntry}>
                            {i18n.t('button.delete')}
                        </Button>
                    </div>
                </div>
            </CustomModal>
        </div>
    )
}

type DiagnosisEntryProps = {
    diagnosis: DiagnosisType
    onEdit: (diagnosis: DiagnosisType) => void
    onDelete: (diagnosisId: string) => void
    hasOperationsErrors?: boolean | undefined | null
}

export default DiagnosisEntry
